import React from 'react';
import { TextUnderline } from '@good/icons';

import { useRichTextEditor } from '../rich-text-editor-context';
import { MenuButton } from './menu-button';

export const UnderlineButton = () => {
  const { editor, disabled } = useRichTextEditor();

  const isDisabled = disabled || !editor.can().chain().focus().toggleUnderline().run();
  const onClick = () => editor.chain().focus().toggleUnderline().run();
  const variant = editor.isActive('underline') ? 'filled' : 'transparent';

  return (
    <MenuButton onClick={onClick} disabled={isDisabled} variant={variant} aria-label='underline'>
      <TextUnderline />
    </MenuButton>
  );
};
